import React, { useEffect, useState } from "react"
import "../Card/newlistingcard.scss"
import VizSensor from "react-visibility-sensor"
import { Link, navigate } from "gatsby"
import PreLoader from "./preloader.png"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"

const MeetingListingCard = props => {
  const [imgViz, setimgViz] = useState(false)
  const [imgVizdisplay, setimgVizdisplay] = useState(false)
  const [showGofloatersAdvatages, setShowGofloatersAdvatages] = useState(false)
  const [showWhatsappContact, setShowWhatsappContact] = useState(false)
  useEffect(() => {
    // Set showGofloatersAdvatages to true on a random basis.
    if (props.index == 4 || props.index == 14 || props.index ==24) {
      setShowGofloatersAdvatages(true);
    }
    if (props.index == 8 || props.index == 18 || props.index == 28) {
      setShowWhatsappContact(true);
    }
  }, [])

  const url = `https://www.gofloaters.com/app/#/home/explore/bookingrequest/${props.spaceId}`

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  const carouselStyle = {
    height: "200px",
    borderRadius: "5px 0 0 5px",
    overflow: "hidden",
    width: "100%",
    height: "100%",
    position: "relative",
  }

  const imageStyle = {
    height: "200px",
    width: "100%",
    objectFit: "cover",
    borderTopLeftRadius: "5px",
  }

  const customDotListStyle = {
    position: "absolute",
    bottom: "10px",
    display: "flex",
    justifyContent: "center",
    padding: 0,
    margin: 0,
    listStyle: "none",
    width: "100%",
  }

  var str = ""
  const HourPrice = () => {
    return (
      <span className="priceTag">
        {props.priceperhrPreDiscount ? (
          <b className="priceStrike">₹ {props.priceperhrPreDiscount} </b>
        ) : (
          ""
        )}
        <b>₹ {props.priceHr}</b>/hour
      </span>
    )
  }

  const ratingText = rating => {
    if (rating > 4.5) {
      return "Very Good"
    } else if (rating >= 3.5 && rating <= 4.5) {
      return "Good"
    } else if (rating >= 2.5 && rating <= 3.5) {
      return "Average"
    } else if (rating < 2.5) {
      return "Below Average"
    }
  }

  let SpaceSuitedFor = ""
  if (props.purposesList) {
    const lastIndex = props.purposesList.length - 1
    SpaceSuitedFor = props.purposesList.map((purpose, index) =>
      <span key={`purpose-${index}`} style={{ fontSize: "12px", borderRadius: "25px", backgroundColor: "#f8f8f8", color: "#303030", padding: "5px 10px", marginRight: "5px", marginTop: "10px", width: "fit-content" }}>{purpose} </span>
    )
  }

  const MonthlyPrice = () => {
    return (
      <span className="priceTag">
        <b>₹ {props.priceMonth}</b>/month
      </span>
    )
  }
  const DailyPrice = () => {
    return (
      <span className="priceTag">
        {props.priceperdayPreDiscount ? (
          <b className="priceStrike">₹ {props.priceperdayPreDiscount} </b>
        ) : (
          ""
        )}
        <b>₹ {props.priceDay}</b>/day
        <br></br>
      </span>
    )
  }
  const DailyFree = () => {
    return (
      <span className="priceTag">
        Daily: NA
        <br></br>
      </span>
    )
  }
  function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === "undefined" || +exp === 0) {
      return Math[type](value)
    }
    value = +value
    exp = +exp
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
      return NaN
    }
    // Shift
    value = value.toString().split("e")
    value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)))
    // Shift back
    value = value.toString().split("e")
    return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp))
  }
  const ceil10 = (value, exp) => decimalAdjust("ceil", value, exp)
  return (
    <div
      className={"col-md-12 align listingCardMeetingSpace" + str}
    >
      <div
        className="listingCardNew"
        onClick={() => {
          navigate(props.Slug)
        }}
        style={{
          borderRadius: "5px",
          border: "1px solid #e0e0e0",
          boxShadow: "none"
        }}
        title={props.gftitle + " - " + props.OriginalName}
      >
        <div className="row no-gutters">
          <div className="col-md-4 cardMobileNoPadding">
            <div className="listingimagesnew">
              <VizSensor
                partialVisibility
                onChange={isVisible => {
                  setimgViz(isVisible)
                  if (!imgVizdisplay) {
                    setimgVizdisplay(isVisible)
                  }
                }}
              >
                <div className="viz-sensor-content">
                  {props.photos && props.photos.length > 0 ? (
                    <Carousel
                      responsive={responsive}
                      infinite={true}
                      autoPlay={true}
                      autoPlaySpeed={3000}
                      style={carouselStyle}
                      showDots={true}
                      dotListClass="custom-dot-list"
                      renderDotsOutside={false}
                      arrows={true}
                      customLeftArrow={
                        <button
                          className="react-multi-carousel-arrow react-multi-carousel-arrow--left"
                          aria-label="Previous slide"
                        >
                          <i className="fa fa-chevron-left" aria-hidden="true"></i>
                        </button>
                      }
                      customRightArrow={
                        <button
                          className="react-multi-carousel-arrow react-multi-carousel-arrow--right"
                          aria-label="Next slide"
                        >
                          <i className="fa fa-chevron-right" aria-hidden="true"></i>
                        </button>
                      }
                    >
                      {props.photos.map((photo, index) => (
                        <img
                          key={index}
                          src={photo}
                          alt={`${props.gftitle} - ${index + 1}`}
                          style={imageStyle}
                        />
                      ))}
                    </Carousel>
                  ) : (
                    <div
                      style={imgVizdisplay ? {
                        ...imageStyle,
                        backgroundImage: `url(${props.listingImg || PreLoader})`,
                        backgroundSize: "cover"
                      } : {
                        ...imageStyle,
                        backgroundImage: `url(${PreLoader})`,
                        backgroundSize: "cover"
                      }}
                    />
                  )}
                </div>
              </VizSensor>
              {props.Rating && (
                <p className="cardRating">
                  <span>{props.Rating} ★</span>
                </p>
              )}
              {props.online && props.meetingInstantBooking && (
                <div className="bookInstant">
                  <span>
                    <i className="fa fa-bolt" aria-hidden="true"></i> Book Instantly
                  </span>
                </div>
              )}
            </div>
          </div>
          <div className="col-md-6 cardMobileNoPadding">
            <div className="listingDetailNewMR">
              <div className="row ">
                <div className="col-12">
                  <div className="MobileOnly" style={{ paddingBottom: "10px" }}>
                    {props.bookingcount > 10 ? (
                      <span
                        style={{
                          padding: "5px 10px",
                          borderRadius: "5px",
                          fontSize: "12px",
                          color: "#303030",
                          background: "#f8f8f8",
                          textWrap: "nowrap",
                          border: "0.5px solid #444",
                        }}
                      >
                        <img
                          src="https://assets.gofloaters.com/popular.png"
                          style={{ width: "15px", height: "15px" }}
                          alt="Popular"
                        />{" "}
                        Popular
                      </span>
                    ) : (
                      ""
                    )}

                    {props.bookingcount > 30 ? (
                      <span
                        style={{
                          padding: "5px 10px",
                          borderRadius: "5px",
                          marginLeft: "10px",
                          fontSize: "12px",
                          color: "#303030",
                          background: "#f8f8f8",
                          border: "0.5px solid #444",
                          textWrap: "nowrap",
                        }}
                      >
                        <img
                          src="https://assets.gofloaters.com/frequently.png"
                          style={{ width: "15px", height: "15px" }}
                          alt="Frequently Booked"
                        />{" "}
                        Frequently Booked
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  {props.spacetype != "Cafe" ? (
                    <h2
                      title={
                        props.spacetype != "Cafe"
                          ? props.spaceDisplayName + " | "
                          : ""
                      }
                    >
                      {props.spacetype != "Cafe"
                        ? props.spaceDisplayName + " | "
                        : ""}
                      {props.spaceAddress}
                      {/*                    
                      {props.Rating ? (
                        <span
                          className={
                            "stars-container stars-" +
                            Number(20) * Number(props.Rating)
                          }
                        >
                          ★★★★★
                        </span>
                      ) : (
                        ""
                      )} */}
                    </h2>
                  ) : (
                    ""
                  )}
                  {props.spacetype === "Cafe" ? (
                    <h2 title={props.gftitle - props.OriginalName}>
                      {props.title}{" "}
                    </h2>
                  ) : (
                    ""
                  )}
                </div>
                {/* <div className="col-3 text-right">
               
              </div> */}

                <div className="col-12">
                  <p className="spaceaddress">
                    {props.OriginalName}
                    {" - "}
                    {props.gftitle}
                    <span className="DesktopOnly">{" | "}</span>
                    <a
                      href={
                        "https://maps.google.com/?q=" +
                        props.geoLocation[0] +
                        "," +
                        props.geoLocation[1]
                      }
                      className="DesktopOnly"
                      target="_blank"
                      style={{ color: "#029eff" }}
                    >
                      Show on map
                    </a>
                  </p>
                </div>
              </div>
              {props.meetingRoomName ? (
                <div className="row">
                  <div className="col-12">
                    <p style={{ fontSize: "12px" }}>
                      <b>Room Name : </b>
                      {props.meetingRoomName}
                    </p>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="row">
                <div className="col-12 featureIcons">
                  {props.Facility.search("Metro Nearby") > 1 ? (
                    <div className="text-center featureIconBox">
                      <img
                        src="https://assets.gofloaters.com/icons/svg/metro_nearby.svg"
                        alt="Hi Speed WiFi"
                        style={{
                          width: "22px",
                        }}
                      ></img>
                      <span>Metro Nearby</span>
                    </div>
                  ) : (
                    ""
                  )}
                  {props.Facility.search("Hi Speed WiFi") > 1 ? (
                    <div className="text-center featureIconBox">
                      <img
                        src="https://assets.gofloaters.com/icons/svg/hi_speed_wifi.svg"
                        alt="Hi Speed WiFi"
                        style={{
                          width: "22px",
                        }}
                      ></img>
                      <span>Hi Speed WiFi</span>
                    </div>
                  ) : (
                    ""
                  )}

                  {props.Facility.search("Whiteboard") > 1 ? (
                    <div className="text-center featureIconBox">
                      <img
                        src="https://assets.gofloaters.com/icons/svg/white_board.svg"
                        alt="Whiteboard"
                        style={{
                          width: "22px",
                        }}
                      ></img>
                      <span>Whiteboard</span>
                    </div>
                  ) : (
                    ""
                  )}
                  {props.Facility.search("Projector") > 1 ? (
                    <div className="text-center featureIconBox">
                      <img
                        src="https://assets.gofloaters.com/icons/svg/projectors.svg"
                        alt="Projector"
                        style={{
                          width: "22px",
                        }}
                      ></img>
                      <span>Projector</span>
                    </div>
                  ) : (
                    ""
                  )}
                  {props.Facility.search("Television") > 1 ? (
                    <div className="text-center featureIconBox">
                      <img
                        src="https://assets.gofloaters.com/icons/svg/television.svg"
                        alt="Television"
                        style={{
                          width: "22px",
                        }}
                      ></img>
                      <span>Television</span>
                    </div>
                  ) : (
                    ""
                  )}
                  {/*                  
                  {props.Facility.search("Free Parking") > 1 ? (
                    <div className="text-center featureIconBox">
                      <img
                        src="https://assets.gofloaters.com/icons/svg/free_parking.svg"
                        alt="Free Parking"
                        style={{
                          width: "22px",
 
                        }}
                      ></img>
                      <span>Free Parking</span>
                    </div>
                  ) : (
                    ""
                  )} */}
                </div>
              </div>

              <div className="row">
                <div className="col-12 idealForList">
                  <p>
                    <b style={{ fontSize: "12px" }}>Ideal for : </b>
                    <br />
                    {SpaceSuitedFor}
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <p style={{ fontSize: "12px" }}>
                    {/* {props.Facility.search("Metro Nearby") > 1 ? (
                      <b
                        style={{
                          color: "#303030",
                          textWrap: "nowrap",
                        }}
                      >
                        Nearby Metro
                      </b>
                    ) : (
                      ""
                    )} */}
                  </p>
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-12">
                  {props.hourPassAvailable && props.priceHr !== " " ? (
                    <HourPrice />
                  ) : (
                    ""
                  )}
                  {props.hourPassAvailable && props.dayPassAvailable
                    ? " | "
                    : ""}
                  {props.dayPassAvailable && props.priceDay !== " " ? (
                    <DailyPrice />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-2 meetingcardButtonNew cardMobileNoPadding">
            <div className="row DesktopOnly">
              <div className="col-12 text-right">
                <p style={{ fontWeight: "bold", fontSize: "18px" }}>
                  {ratingText(props.Rating)}
                  <span style={{ display: "block", fontSize: "10px" }}>
                    {Number(props.googleReviewCount || 0) +
                      Number((props.spaceFeedback && props.spaceFeedback.length) || 0)}{" "}
                    reviews
                  </span>
                </p>
              </div>
            </div>

            {/* <div className="row MobileOnly">
              <div className="col-2">
                <span className="ratingBubble">{props.Rating}</span>
              </div>
              <div className="col-8 text-left">
                <p style={{ fontWeight: "bold", fontSize: "18px" }}>
                  {ratingText(props.Rating)}
                  <span style={{ display: "block", fontSize: "10px" }}>
                    {Number(props.googleReviewCount) +
                      Number(props.spaceFeedback.length)}{" "}
                    reviews
                  </span>
                </p>
              </div>
            </div> */}

            <div
              className="text-right DesktopOnly"
              style={{ paddingBottom: "10px" }}
            >
              {props.bookingcount > 10 ? (
                <span
                  style={{
                    padding: "5px 10px",
                    borderRadius: "5px",
                    fontSize: "12px",
                    color: "#303030",
                    background: "#f8f8f8",
                    textWrap: "nowrap",
                    border: "0.5px solid #444",
                  }}
                >
                  <img
                    src="https://assets.gofloaters.com/popular.png"
                    style={{ width: "15px", height: "15px" }}
                    alt="Popular"
                  />{" "}
                  Popular
                </span>
              ) : (
                ""
              )}

              {props.bookingcount > 30 ? (
                <span
                  style={{
                    padding: "5px 10px",
                    borderRadius: "5px",
                    marginLeft: "10px",
                    fontSize: "12px",
                    color: "#303030",
                    background: "#f8f8f8",
                    textWrap: "nowrap",
                    border: "0.5px solid #444",
                  }}
                >
                  <img
                    src="https://assets.gofloaters.com/frequently.png"
                    style={{ width: "15px", height: "15px" }}
                    alt="Frequently Booked"
                  />{" "}
                  Frequently Booked
                </span>
              ) : (
                ""
              )}
            </div>

            {props.online ? (
              <Link to={props.Slug}>View Details</Link>
            ) : (
              <a href={props.Slug + "/"} target="_blank">
                Currently unavailable
              </a>
            )}
          </div>
        </div>
      </div>
      {/* if showGofloatersAdvatages is true then show a div */}
      {showGofloatersAdvatages && (
        <div
          style={{
            padding: "10px 15px 20px",
            // border: "1px solid #2193b0",
            borderRadius: "5px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            backgroundImage:
              "linear-gradient(to right, #def4ff, #f0f9ff)",
          }}
        >
          <div className="row">
            <div className="col-md-12">
              <h4 id="amenities">GoFloaters Advantage</h4>
            </div>
            <div className="col-md-6 col-12">
              <div className="row aligner paddingTriggerTwo">
                <div className="col-md-3 col-3 text-center">
                  <img
                    src="https://assets.gofloaters.com/icons/svg/lower-price.svg"
                    style={{ width: "36px" }}
                  ></img>
                </div>
                <div className="col-md-9 col-9">
                  <h2
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                  >
                    Lowest Price Guaranteed
                  </h2>
                  {/* <p>
                                  You can trust us with our fair and dependable
                                  prices.
                                </p> */}
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row aligner paddingTriggerTwo">
                <div className="col-md-3 col-3 text-center">
                  <img
                    src="https://assets.gofloaters.com/icons/svg/free-rescheduling.svg"
                    style={{ width: "36px" }}
                  ></img>
                </div>
                <div className="col-md-9 col-9">
                  <h2
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                  >
                    Free Rescheduling
                  </h2>
                  {/* <p>
                                  You can modify the date,time and other details of
                                  your scheduled booking .
                                </p> */}
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row aligner paddingTriggerTwo">
                <div className="col-md-3 col-3 text-center">
                  <img
                    src="https://assets.gofloaters.com/icons/svg/free-cancellation.svg"
                    style={{ width: "36px" }}
                  ></img>
                </div>
                <div className="col-md-9 col-9">
                  <h2
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                  >
                    Free Cancellation
                  </h2>
                  {/* <p>You can cancel booking upto 48 hours</p> */}
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row aligner paddingTriggerTwo">
                <div className="col-md-3 col-3 text-center">
                  <img
                    src="https://assets.gofloaters.com/icons/svg/instant-confirmations.png"
                    style={{ width: "36px" }}
                  ></img>
                </div>
                <div className="col-md-9 col-9">
                  <h2
                    style={{ fontWeight: "bold", fontSize: "17px" }}
                  >
                    Instant Confirmations
                  </h2>
                  {/* <p>You can cancel booking upto 48 hours</p> */}
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row aligner paddingTriggerTwo">
                <div className="col-md-3 col-3 text-center">
                  <img
                    src="https://assets.gofloaters.com/icons/svg/verified-listings.png"
                    style={{ width: "36px" }}
                  ></img>
                </div>
                <div className="col-md-9 col-9">
                  <h2
                    style={{ fontWeight: "bold", fontSize: "17px" }}
                  >
                    Verified listings
                  </h2>
                  {/* <p>You can cancel booking upto 48 hours</p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* if showWhatsappContact is true then show a div */}
      {showWhatsappContact && (
        <div>
        <div
          className="ratingBoxPage DesktopOnly"
          style={{ padding: "10px", marginTop: "20px" }}
        >
          <div>
            <h5 style={{ fontSize: "24px", fontWeight: "bold" }}>
              Need help in choosing the right meeting space?
            </h5>
            <div className="row aligner">
              <div
                className="col-md-3"
                style={{ padding: "0 10px", textAlign: "center" }}
              >
                <img
                  src="https://assets.gofloaters.com/ajay.png"
                  style={{ width: "30%" }}
                ></img>
                <p>
                  <b>Ajay</b> <br />
                  <span>Sales Expert</span>
                  <br />
                </p>
              </div>
              <div
                className="col-md-7"
                style={{ padding: "0 10px" }}
              >
                <p style={{ fontSize: "16px" }}>
                  Ajay and his team have assisted 120+ clients with
                  meeting space solutions
                </p>
                <img
                  src="https://assets.gofloaters.com/clients/newset/chargebee.png"
                  style={{ height: "20px" }}
                ></img>{" "}
                <img
                  src="https://assets.gofloaters.com/clients/newset/bira.png"
                  style={{ height: "25px" }}
                ></img>{" "}
                <img
                  src="https://assets.gofloaters.com/clients/newset/infeedo.png"
                  style={{ height: "20px" }}
                ></img>{" "}
                <img
                  src="https://assets.gofloaters.com/clients/newset/wingify.png"
                  style={{ height: "20px" }}
                ></img>{" "}
                <img
                  src="https://assets.gofloaters.com/clients/decalthlon.png"
                  style={{ height: "20px" }}
                ></img>
              </div>
              <div className="col-md-2">
                <a
                  href="https://wame.pro/gofloaters"
                  target="_blank"
                  style={{
                    padding: "10px 15px",
                    color: "#fff",
                    background: "rgb(5,167,81)",
                    borderRadius: "15px",
                    background:
                      "linear-gradient(90deg, rgba(5,167,81,1) 0%, rgba(124,194,65,1) 50%)",
                    fontSize: "18px",
                    marginTop: "15px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  <i
                    class="fa fa-whatsapp"
                    aria-hidden="true"
                    style={{
                      fontSize: "20px",
                      paddingRight: "7px",
                    }}
                  ></i>{" "}
                  Connect
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          className="ratingBoxPage MobileOnly"
          style={{ padding: "10px", marginTop: "20px" }}
        >
          <div>
            <h5 style={{ fontSize: "24px", fontWeight: "bold" }}>
              Need help in choosing the right meeting space?
            </h5>
            <div className="row aligner">
              <div
                className="col-md-3 col-3"
                style={{ padding: "0 10px" }}
              >
                <img
                  src="https://assets.gofloaters.com/ajay.png"
                  style={{ width: "100%" }}
                ></img>
              </div>
              <div
                className="col-md-4 col-4"
                style={{ padding: "0 10px" }}
              >
                <p>
                  <b>Ajay</b> <br />
                  <span>Sales Expert</span>
                  <br />
                </p>
              </div>
              <div className="col-md-5 col-5">
                <a
                  href="https://wame.pro/gofloaters"
                  target="_blank"
                  style={{
                    padding: "10px 15px",
                    color: "#fff",
                    background: "rgb(5,167,81)",
                    borderRadius: "15px",
                    background:
                      "linear-gradient(90deg, rgba(5,167,81,1) 0%, rgba(124,194,65,1) 50%)",
                    fontSize: "18px",
                    marginTop: "15px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <i
                    class="fa fa-whatsapp"
                    aria-hidden="true"
                    style={{
                      fontSize: "20px",
                      paddingRight: "7px",
                    }}
                  ></i>{" "}
                  Connect
                </a>
              </div>
              <div className="col-md-12 text-center">
                <hr />
                <p style={{ fontSize: "16px" }}>
                  Ajay and his team have assisted 120+ clients with
                  meeting space solutions
                </p>
                <img
                  src="https://assets.gofloaters.com/clients/newset/chargebee.png"
                  style={{ height: "20px" }}
                ></img>{" "}
                <img
                  src="https://assets.gofloaters.com/clients/newset/bira.png"
                  style={{ height: "25px" }}
                ></img>{" "}
                <img
                  src="https://assets.gofloaters.com/clients/newset/infeedo.png"
                  style={{ height: "20px" }}
                ></img>{" "}
                <img
                  src="https://assets.gofloaters.com/clients/newset/wingify.png"
                  style={{ height: "20px" }}
                ></img>{" "}
                <img
                  src="https://assets.gofloaters.com/clients/decalthlon.png"
                  style={{ height: "20px" }}
                ></img>
              </div>
            </div>
          </div>
        </div>
        </div>
      )}
    </div>
  )
}
export default MeetingListingCard
